import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "grading-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M8.573 16.677C8.15878 16.677 7.823 16.3412 7.823 15.927V13.341C7.823 12.8809 8.00416 12.4364 8.3315 12.1078L8.33564 12.1037L12.3356 8.10367C13.0192 7.42015 14.1276 7.41918 14.811 8.10435L16.3964 9.68967C17.0799 10.3732 17.0808 11.4816 16.3956 12.165L12.4034 16.1573L12.3964 16.1643C12.0691 16.4916 11.6235 16.677 11.1591 16.677L8.573 16.677ZM13.3963 9.16433C13.4948 9.06585 13.6524 9.06683 13.749 9.16365L13.7554 9.17006L15.3357 10.7503C15.4342 10.8488 15.4331 11.0064 15.3363 11.103L11.3356 15.1037L11.3322 15.1071C11.2858 15.1517 11.223 15.177 11.1591 15.177H9.323V13.341C9.323 13.2737 9.34977 13.2106 9.39491 13.1657L9.4005 13.1601L13.3963 9.16433Z"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M18.8943 19.3943C22.7019 15.5867 22.7019 9.41332 18.8943 5.60571C15.0867 1.7981 8.91332 1.7981 5.10571 5.60571C1.2981 9.4133 1.2981 15.5867 5.10571 19.3943C8.9133 23.2019 15.0867 23.2019 18.8943 19.3943ZM6.16637 6.66637C9.3882 3.44454 14.6118 3.44454 17.8336 6.66637C21.0551 9.88823 21.0553 15.1119 17.8336 18.3336C14.6118 21.5554 9.38818 21.5554 6.16637 18.3336C2.94454 15.1118 2.94455 9.88818 6.16637 6.66637Z"
    }, null, -1)
  ])))
}
export default { render: render }